import { mapCmsSeoDataToSeoMeta } from '@/lib/cms-mappers/common.mappers';
import { mapCmsShowcaseDataToShowcaseHelpProps } from '@/lib/cms-mappers/showcase/help.mappers';

import type { FcwShowcaseHelpTemplateProps } from '@/components/templates/FcwShowcaseHelpTemplate.vue';

/**
 * Returns showcase help page data fetched from CMS (Strapi)
 */
export async function useCmsShowcaseHelp(): UseCmsResponse<
  FcwShowcaseHelpTemplateProps,
  'seoData'
> {
  const { data, error, pending, refresh } = await useStrapi('showcase-help', {
    queryParams: {
      populate: [
        'faqs.sharing_faq_items',
        'faqs.leasing_faq_items',
        'seo.image',
      ].join(','),
    },
  });
  const mappedData = computed(() =>
    mapCmsShowcaseDataToShowcaseHelpProps(data.value?.data)
  );

  const seoData = computed(() =>
    mapCmsSeoDataToSeoMeta(data.value?.data?.attributes?.seo)
  );

  return { data: mappedData, seoData, error, pending, refresh };
}
